import { faCashRegister } from '@fortawesome/pro-light-svg-icons';

import { LocationType } from 'src/app/models';
import { NavigationItem } from 'src/app/pages/pos-manager/main/main.page';
export class PagePath {
  static readonly DINING_ROOM_PAGE = 'dining-room';
  static readonly FLOOR_PLAN_PAGE = 'floor-plan';
  static readonly HOST_MODE_FLOOR_PLAN_PAGE = 'host-mode';
  static readonly TAKEOUT_DELIVERY_PAGE = 'takeout-delivery';
  static readonly RESERVATION = 'reservation';
  static readonly RESERVATION_NEW = 'new';
  static readonly LISTING = 'listing';
  static readonly MODIFIER_PROMPTS = 'modifier-prompts';
  static readonly POS_ITEMS_MANAGEMENT = 'pos-items-management';
  static readonly TABLES_MANAGEMENT = 'tables-management';
  static readonly POS_OPERATORS_MANAGEMENT = 'pos-operators-management';
  static readonly REPORTING = 'reporting';
  static readonly REPORTS = 'reports';
  static readonly END_OF_DAY_REPORT = 'end-of-day-report';
  static readonly CLOSING_THE_DAY = 'closing-the-day';
  static readonly REALTIME_INFO = 'realtime-info';
  static readonly TOTAL_SALE_BY_CATEGORY = 'total-sale-by-category';
  static readonly POS_OPERATORS = 'pos-operators';
  static readonly SCHEDULES_SERVICES = 'schedules-services';
  static readonly UNPAID = 'unpaid';
  static readonly PAID = 'paid';
  static readonly PAYMENT = 'payment';
  static readonly POS_MANAGER = 'pos-manager';
  static readonly SUPPORT = 'support';
  static readonly LOGIN = 'login';
  static readonly PRINTERS_MANAGEMENT = 'printers-management';
}

export class PageConstant {
  //Common Pages
  static readonly DEVICE_REGISTRATION_PAGE = 'device-registration';
  static readonly LOGIN_PAGE = 'login';
  static readonly PAYMENTS_PAGE = 'payments';
  static readonly TRANSACTIONS_PAGE = 'transactions';
  //Dining Room pages
  static readonly DINING_ROOM_PAGE = `${PagePath.DINING_ROOM_PAGE}`;
  static readonly DINING_FLOORPLAN_PAGE = `${PagePath.DINING_ROOM_PAGE}/${PagePath.FLOOR_PLAN_PAGE}`;
  static readonly DINING_TAKEOUT_PAGE = `${PagePath.DINING_ROOM_PAGE}/${PagePath.TAKEOUT_DELIVERY_PAGE}`;
  static readonly CHECKOUT_PAGE = 'checkout';
  static readonly TABLES_ASSIGNMENT_PAGE = 'tables-assignment';

  //Host Mode
  static readonly DINING_HOST_MODE_PAGE = `${PagePath.DINING_ROOM_PAGE}/${PagePath.HOST_MODE_FLOOR_PLAN_PAGE}`;
  static readonly HOST_MODE_RESERVATION = `${PageConstant.DINING_HOST_MODE_PAGE}/${PagePath.RESERVATION}`;
  static readonly HOST_MODE_RESERVATION_NEW = `${PageConstant.HOST_MODE_RESERVATION}/${PagePath.RESERVATION_NEW}`;
  //Quick Service pages
  static readonly QUICK_SERVICE_PAGE = 'quick-service';
  //Self Service
  static readonly SELF_SERVICE_SETUP_PAGE = 'self-service/setup';
  static readonly SELF_SERVICE_ORDERING_PAGE = 'self-service/ordering';
  static readonly SELF_SERVICE_PAYMENT_PAGE = 'self-service/payment';
  //POS Manager
  static readonly POS_MANAGER_MODIFIER_PROMPTS_PAGE = `${PagePath.POS_MANAGER}/${PagePath.MODIFIER_PROMPTS}`;
  static readonly POS_MANAGER_POS_ITEMS_MANAGEMENT_PAGE = `${PagePath.POS_MANAGER}/${PagePath.POS_ITEMS_MANAGEMENT}`;
  static readonly POS_MANAGER_TABLES_MANAGEMENT_PAGE = `${PagePath.POS_MANAGER}/${PagePath.TABLES_MANAGEMENT}`;
  static readonly POS_MANAGER_POS_OPERATORS_MANAGEMENT_PAGE = `${PagePath.POS_MANAGER}/${PagePath.POS_OPERATORS_MANAGEMENT}`;
  static readonly POS_MANAGER_SCHEDULES_SERVICES_PAGE = `${PagePath.POS_MANAGER}/${PagePath.SCHEDULES_SERVICES}`;
  static readonly POS_MANAGER_REPORTING_PAGE = `${PagePath.POS_MANAGER}/${PagePath.REPORTING}`;
  static readonly POS_MANAGER_REPORTS_PAGE = `${PagePath.POS_MANAGER}/${PagePath.REPORTS}`;
  static readonly POS_MANAGER_POS_REAL_TIME_INFO_PAGE = `${PagePath.POS_MANAGER}/${PagePath.REALTIME_INFO}`;
  static readonly POS_MANAGER_REAL_TIME_INFO_TOTAL_SALE_BY_CATEGORY_PAGE = `${PagePath.POS_MANAGER}/${PagePath.REALTIME_INFO}/${PagePath.TOTAL_SALE_BY_CATEGORY}`;
  static readonly POS_MANAGER_REAL_TIME_INFO_POS_OPERATORS_PAGE = `${PagePath.POS_MANAGER}/${PagePath.REALTIME_INFO}/${PagePath.POS_OPERATORS}`;

  static readonly POS_MANAGER_PRODUCT_EDIT_PAGE = `${PagePath.POS_MANAGER}/product-edit`;
  static readonly TAKEOUT_DELIVERY_PAGE = (isDiningRoom: boolean) =>
    isDiningRoom
      ? PageConstant.DINING_TAKEOUT_PAGE
      : PagePath.TAKEOUT_DELIVERY_PAGE;
  static readonly TAKEOUT_DELIVERY_ORDER_PAGE = (isDiningRoom: boolean) =>
    `${PageConstant.TAKEOUT_DELIVERY_PAGE(isDiningRoom)}/order`;
  static readonly TAKEOUT_DELIVERY_NEW_ORDER_PAGE = (isDiningRoom: boolean) =>
    `${PageConstant.TAKEOUT_DELIVERY_ORDER_PAGE(isDiningRoom)}/new`;
  static readonly TAKEOUT_DELIVERY_VIEW_ORDER_PAGE = (isDiningRoom: boolean) =>
    `${PageConstant.TAKEOUT_DELIVERY_ORDER_PAGE(isDiningRoom)}/detail`;

  static readonly HARDWARE_DEV_TEST = 'hardware-dev-test';

  //Services Location
  static readonly SERVICES_BOOKING_PAGE = 'services/booking';
  static readonly SERVICES_APPOINTMENTS_PAGE = 'services/appointments';
  static readonly SERVICES_SEARCH_APPOINTMENTS_PAGE =
    'services/search-appointments';
  static readonly SERVICES_SHOP_PAGE = 'services/shop';

  //Census Report
  static readonly CENSUS_REPORT = 'census-report';
  static readonly SETUP = 'setup';

  //Printers Management
  static readonly PRINTERS_MANAGEMENT_PAGE = PagePath.PRINTERS_MANAGEMENT;

  static readonly POS_MANAGER_MENU_NAV_ITEMS: Partial<NavigationItem>[] = [
    {
      icon: {
        svgIcon: '../../assets/icon/icon-items-management.svg'
      },
      name: 'posManager.posItemManagement',
      routerLink: '/' + PageConstant.POS_MANAGER_POS_ITEMS_MANAGEMENT_PAGE
    },
    {
      icon: {
        svgIcon: '../../assets/icon/icon-modifierprompts.svg'
      },
      name: 'posManager.modifierPrompts',
      routerLink: '/' + PageConstant.POS_MANAGER_MODIFIER_PROMPTS_PAGE
    },
    {
      icon: {
        svgIcon: '../../assets/icon/icon-table-management.svg'
      },
      name: 'posManager.tableManagement',
      routerLink: '/' + PageConstant.POS_MANAGER_TABLES_MANAGEMENT_PAGE
    },
    {
      icon: {
        svgIcon: '../../assets/icon/icon-operator.svg'
      },
      name: 'posManager.operators',
      routerLink: '/' + PageConstant.POS_MANAGER_POS_OPERATORS_MANAGEMENT_PAGE
    },
    {
      permissionKey: 'schedules_and_services',
      icon: {
        svgIcon: '../../assets/icon/icon-schedule-service.svg'
      },
      name: 'posManager.schedulesAndServices',
      routerLink: '/' + PageConstant.POS_MANAGER_SCHEDULES_SERVICES_PAGE
    },
    {
      icon: {
        faIcon: faCashRegister
      },
      name: 'posManager.closingTheDay',
      routerLink: '/' + PagePath.POS_MANAGER + '/' + PagePath.CLOSING_THE_DAY,
      permissionKey: 'closing_the_day'
    },
    {
      permissionKey: 'closing_the_day',
      icon: {
        svgIcon: '../../assets/icon/file-lines.svg'
      },
      name: 'posManager.reports',
      routerLink: '/' + PageConstant.POS_MANAGER_REPORTS_PAGE
    },
    {
      icon: {
        svgIcon: '../../assets/icon/fa-chart-mixed.svg'
      },
      name: 'posManager.realTimeInfo',
      routerLink: '/' + PageConstant.POS_MANAGER_POS_REAL_TIME_INFO_PAGE
    }
  ];

  static readonly LOCATION_ROOT_URL_MAPPER: Record<LocationType, string> = {
    [LocationType.DiningRoom]: PageConstant.DINING_FLOORPLAN_PAGE,
    [LocationType.QuickService]: PageConstant.QUICK_SERVICE_PAGE,
    [LocationType.SelfServe]: PageConstant.SELF_SERVICE_SETUP_PAGE,
    [LocationType.Services]: PageConstant.SERVICES_BOOKING_PAGE
  };
}
